import { useRef, useCallback } from 'react';

const MAX_LINES = 200;

/**
 * Hook to manage terminal output buffer for AI agent diagnostics.
 * Stores the last N lines of terminal output.
 */
export function useTerminalBuffer() {
    const bufferRef = useRef<string[]>([]);

    const appendOutput = useCallback((output: string) => {
        const newLines = output.split('\n');
        bufferRef.current = [...bufferRef.current, ...newLines].slice(-MAX_LINES);
    }, []);

    const getOutput = useCallback(() => {
        return bufferRef.current.join('\n');
    }, []);

    const clear = useCallback(() => {
        bufferRef.current = [];
    }, []);

    return { appendOutput, getOutput, clear };
}
